<template>
  <div :class="divWidthChange" class="conteudoWidth">
    <div class="titlePage">{{ titlePage }}</div>
    <div class="row mt-3">
      <div class="col-sm-12">
        <fccTable
          striped
          hover
          :fields="fieldsOutrasFases"
          :orderby="sortBy"
          :actions="actionsOutrasFases"
          :items="lstOutrasFases"
          responsive
          add-filter
          pdf
          csv
          :porPage="itemPorPage"
          :titlePage="titlePage"
          :titlePDF="titlePage"
        ></fccTable>
      </div>
    </div>
    <fcc-modal
      centered
      id-modal="outrasFasesOpen"
      title-modal="Outras fases"
      esconde-footer
      trava-esc
      size="lg"
      trava-back
    >
      <b-form
        @submit.prevent="criarOutraFase.idoutfase == 0 ? submitOutraFase() : editOutraFase()"
        autocomplete="off"
      >
        <div class="row mt-3">
          <div class="col-sm-6">
            <fcc-input v-model="criarOutraFase.spi" disabled>SPI</fcc-input>
          </div>
          <div class="col-sm-6">
            <fcc-input v-model="criarOutraFase.idpublicacao" disabled>ID Publicação</fcc-input>
          </div>
        </div>
        <div class="row mt-3">
          <div class="col-sm-12">
            <fcc-input v-model="criarOutraFase.titulobotao" required>Título</fcc-input>
          </div>
        </div>
        <div class="row mt-3">
          <div class="col-sm-12">
            <fcc-editor v-model="criarOutraFase.descricao"></fcc-editor>
          </div>
        </div>
        <div class="row mt-3">
          <div class="col-sm-6">
            <fcc-input v-model="criarOutraFase.rota" required>Rota</fcc-input>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-6 mt-1">
            <div class="publicaBox">
              <div class="row">
                <div class="col-sm-12 mt-1">
                  <fccDateInput
                    id="dtFinalDisponivel"
                    type="datetime"
                    class="form-control"
                    v-model="criarOutraFase.datainicio"
                    required
                  >
                    Data Início
                  </fccDateInput>
                </div>
              </div>
            </div>
          </div>
          <div class="col-sm-6 mt-1">
            <div class="publicaBox">
              <div class="row">
                <div class="col-sm-12 mt-1">
                  <fccDateInput
                    id="dtFinalDisponivel"
                    type="datetime"
                    class="form-control"
                    v-model="criarOutraFase.datafim"
                    :min-datetime="criarOutraFase.datainicio"
                    required
                  >
                    Data final(*)
                  </fccDateInput>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row innerPage" v-if="criarOutraFase.idoutfase > 0">
          <div class="col-sm-12">
            <fcc-galeria
              cod-arq-cad="FORMULARIO_DINAMICO"
              :extArqPermitido="['jpeg', 'jpg', 'png', 'mp4', 'pdf']"
              :id-externo="
                'outra-fase_' + controlePage.idpublicacao + '_' + criarOutraFase.idoutfase
              "
              exibe-imagens
              tipo="tabela"
              :arqMaxSize="200"
              :arqMaxQtde="10"
            ></fcc-galeria>
          </div>
        </div>
        <div class="row innerPage">
          <div class="col-sm-3">
            <toggle-button v-model="criarOutraFase.camposficha" />
            Campos da ficha
          </div>
          <div class="col-sm-3">
            <toggle-button v-model="criarOutraFase.semarquivos" />
            Sem arquivos
          </div>
          <div class="col-sm-3">
            <toggle-button v-model="criarOutraFase.manterarquivos" />
            Manter arquivos
          </div>
          <div class="col-sm-3">
            <toggle-button v-model="criarOutraFase.ativo" />
            Status
          </div>
        </div>

        <div class="row innerPage">
          <div class="col-sm-3 ml-auto">
            <fccButton classeAdd="form-control" tipo="submit">{{ labelsSystem.salvar }}</fccButton>
          </div>
        </div>
      </b-form>
    </fcc-modal>
    <fcc-modal
      centered
      id-modal="arquivosModal"
      title-modal="Arquivos"
      esconde-footer
      trava-esc
      size="xl"
      trava-back
      @close="idoutfase = 0"
    >
      <fcc-arquivos
        v-if="idoutfase > 0"
        :baseUrlPublicacao="baseUrlPublicacao"
        :idPublicacao="controlePage.idpublicacao"
        :idoutfase="idoutfase"
      />
    </fcc-modal>
    <fcc-modal
      centered
      id-modal="importacaoCandidatos"
      title-modal="Importar Candidatos"
      esconde-footer
      trava-esc
      size="xl"
      trava-back
    >
      <fcc-importacao-candidatos
        :baseUrlPublicacao="baseUrlPublicacao"
        :idoutfase="idoutfase"
        :controlePage="controlePage"
      />
    </fcc-modal>
    <fcc-modal
      centered
      id-modal="listarCandidatos"
      title-modal="Listar Candidatos"
      esconde-footer
      trava-esc
      size="xl"
      trava-back
    >
      <fcc-listar-candidatos
        :baseUrlPublicacao="baseUrlPublicacao"
        :idoutfase="idoutfase"
        :controlePage="controlePage"
      />
    </fcc-modal>
  </div>
</template>
<script>
import store from '@/store'
import axios from 'axios'
import fccArquivos from './fccArquivos.vue'
import fccImportacaoCandidatos from './fccImportacaoCandidatos/fccImportacaoCandidatos.vue'
import fccListarCandidatos from './fccListarCandidatos.vue'

export default {
  data() {
    return {
      lstOutrasFases: [],
      idoutfase: 0,
      titlePage: 'Outras Fases',
      sortBy: 'nome',
      itemPorPage: '1000',
      idNotificacao: 0,
      criarOutraFase: {},
      actionsOutrasFases: [
        {
          button: true,
          funcaoButton: 'viewFase',
          icon: 'edit',
          tooltip: 'Editar',
          objpermCodigo: store.state.permissaoMenu.editar
        },
        {
          button: true,
          funcaoButton: 'abrirArquivos',
          icon: 'file',
          tooltip: 'Arquivos',
          objpermCodigo: store.state.permissaoMenu.editar
        },
        {
          button: true,
          funcaoButton: 'importarCandidatos',
          icon: 'file-import',
          tooltip: 'Importar candidatos',
          objpermCodigo: store.state.permissaoMenu.editar
        },
        {
          button: true,
          funcaoButton: 'listarCandidatos',
          icon: 'users',
          tooltip: 'Listar candidatos',
          objpermCodigo: store.state.permissaoMenu.editar
        },
        {
          button: true,
          funcaoButton: 'deletarOutrasFases',
          icon: 'trash',
          tooltip: 'Deletar fase',
          objpermCodigo: store.state.permissaoMenu.editar
        }
      ],
      fieldsOutrasFases: [
        { key: 'idoutfase', label: 'ID', sortable: true },
        { key: 'titulobotao', label: 'Título', sortable: true },
        { key: 'datainicio', label: 'Data Início' },
        { key: 'datafim', label: 'Data Fim' },
        { key: 'actions', label: '' }
      ]
    }
  },
  components: {
    fccArquivos,
    fccImportacaoCandidatos,
    fccListarCandidatos
  },
  props: {
    controlePage: Object,
    baseUrlPublicacao: String
  },
  methods: {
    submitOutraFase() {
      this.carregaTexto(this.codeMensagem('C01'))
      axios
        .post(
          this.baseUrlPublicacao + 'PublicacaoOutrasFases/InserirPublicacaoOutrasFases',
          this.criarOutraFase,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then(() => {
          this.carregaOutrasFases()
          this.callToast(this.mensagensUpdate.adicionado, 'success', 'success')
          this.$root.$emit('bv::hide::modal', 'outrasFasesOpen')
        })
        .catch(this.setErrorSystem)
    },
    editOutraFase() {
      this.carregaTexto(this.codeMensagem('C01'))
      axios
        .put(
          this.baseUrlPublicacao + 'PublicacaoOutrasFases/AlterarPublicacaoOutrasFases',
          this.criarOutraFase,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then(() => {
          this.carregaOutrasFases()
          this.callToast(this.mensagensUpdate.editado, 'success', 'success')
          this.$root.$emit('bv::hide::modal', 'outrasFasesOpen')
        })
        .catch(this.setErrorSystem)
    },
    viewFase(_, item) {
      this.criarOutraFase = { ...item }

      this.$root.$emit('bv::show::modal', 'outrasFasesOpen')
    },
    abrirArquivos(_, item) {
      this.idoutfase = item.idoutfase
      this.$root.$emit('bv::show::modal', 'arquivosModal')
    },
    deletarOutrasFases(_, item) {
      this.callConfirm('Deseja excluir fase?', '').then(() => {
        this.carregaTexto(this.codeMensagem('C03'))
        axios
          .delete(
            this.baseUrlPublicacao +
              'PublicacaoOutrasFases/ExcluirPublicacaoOutrasFases?id=' +
              item.idoutfase,
            this.dadosLoginSession.fccTokenHeaders
          )
          .then(() => {
            this.carregaOutrasFases()
            this.callToast(this.mensagensUpdate.excluido, 'success', 'success')
          })
          .catch(this.setErrorSystem)
          .finally(this.carregaTexto)
      })
    },
    addField() {
      this.criarOutraFase = {}
      this.criarOutraFase.idoutfase = 0
      this.criarOutraFase.idpublicacao = this.controlePage.idpublicacao
      this.criarOutraFase.spi = this.controlePage.spi
      this.criarOutraFase.status = true
      this.criarOutraFase.manterarquivos = false
      this.$root.$emit('bv::show::modal', 'outrasFasesOpen')
    },
    carregaOutrasFases() {
      this.carregaTexto(this.codeMensagem('C01'))
      axios
        .get(
          this.baseUrlPublicacao +
            'PublicacaoOutrasFases/ListarPublicacaoOutrasFasesPorIdPublicacao/' +
            this.controlePage.idpublicacao,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then((response) => {
          this.lstOutrasFases = response.data
        })
        .catch(this.setErrorSystem)
        .finally(this.carregaTexto)
    },
    importarCandidatos(_, item) {
      this.idoutfase = item.idoutfase
      this.$root.$emit('bv::show::modal', 'importacaoCandidatos')
    },
    listarCandidatos(_, item) {
      this.idoutfase = item.idoutfase
      this.$root.$emit('bv::show::modal', 'listarCandidatos')
    }
  },
  mounted() {
    this.carregaOutrasFases()
  }
}
</script>
